import Vue from 'vue';
import axios from 'axios';
import * as moment from 'moment';
import * as _ from 'underscore';
import MenuXMLParser from './MenuXMLParser.js';

moment.locale('de');

const dataProvider = new MenuXMLParser();
const app = new Vue({ 
    el: '#app',
    data: {
        loading: true,
        days: [],
        index: null,
        showAdditives: true,
        //showBackedPrice: false,
        showMealColors: true,
        showNutrition: true,
        showDropdown: true,
        demoVal: {
            icons: ['A','B']
        },
        settings: {
            icons: []
        }
    },
    created: function(){
        this.showAdditives = !(this.getQueryParam('showAdditives')==0);
        //this.showBackedPrice = this.getQueryParam('showBackedPrice')==1;
        this.showMealColors = (this.getQueryParam('showMealColors')==0 ? false : true);
        this.showNutrition = (this.getQueryParam('showNutrition')==0 ? false : true);
        this.showDropdown = (this.getQueryParam('showDropdown')==0 ? false : true);
        var url = this.getQueryParam('current_url');

        var self = this;
        axios.get("/settings.json", {
            'responseType': 'json',
        })
        .then((response) => {
            if(response.data !== null){
                self.settings = response.data;
            }
        });

        dataProvider.init(url)
        .then(resp => {
            this.days = dataProvider.getData().days;
            return dataProvider.init(url.replace('CurrentWeek', 'NextWeek'))
                .then(resp => {
                    this.days = this.days.concat(dataProvider.getData().days);
                });
        })
        .then(resp => { 
            _.each(this.days, function(day){
                day.date_day = moment(day.date, 'YYYY-MM-DD').format('dddd');
                day.date_formatted = moment(day.date, 'YYYY-MM-DD').format('DD.MM.YYYY');
            });
            var today = moment().dayOfYear();
            this.index = _.findIndex(this.days, function(day){ 
                return moment(day.date, 'YYYY-MM-DD').dayOfYear() >= today;
            });
            this.loading = false;
        });
    },
    computed: {
        hasNextDay: function () {
            return this.index < this.days.length -1;
        },
        hasPrevDay: function () {
            return this.index > 0;
        },
    },
    methods: {
        mapIconToMenu: function (menu) {
            var icon = this.settings.icon_default;
            this.settings.icons.forEach(element => {
                if(menu.category.indexOf(element.category) !== -1){
                    icon = element.icon;
                }
            });
            return icon;
        },
        mapCategoryToClass: function(category) {
            if(!this.showMealColors) {
                return '';
            }

            switch (category.substring(0,5)) {
                case 'Tages':
                    return 'is-soup';
                    break;
                case 'Medit':
                    return 'is-med';
                    break;
                case 'Natur':
                    return 'is-nature';
                    break;
                case 'Tradi':
                    return 'is-traditional';
                    break;
                case 'Desse':
                    return 'is-dessert';
                    break;
            }
        },
        lastInCategoryClass: function(index, key) {
            if(key + 1 < this.days[index].menus.length && this.days[index].menus[key].category.substring(0,5) != this.days[index].menus[key + 1].category.substring(0,5)){
                return 'last-in-category';
            }
            return '';
        },
        nextDay: function() {
            this.index++;
        },
        prevDay: function() {
            this.index--
        },
        getQueryParam: function(param) {
            var url = new URL(location.href);
            return url.searchParams.get(param);
        }
    }
});



// WEBPACK FOOTER //
// ./src/main.js